// :cow: Cosmose CONFIDENTIAL :iso:
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

const translates = [marker('PAYMENTS'), marker('UNIQUE_VISITS'), marker('VISITS'), marker('PAYING'), marker('NONPAYING')];

export enum ChartExtendedDataType {
  PAYMENTS = 'PAYMENTS',
  NONPAYING = 'NONPAYING',
  PAYING = 'PAYING',
  UNIQUE_VISITS = 'UNIQUE_VISITS',
  VISITS = 'VISITS',
}
